const pseudoFunction = {
    firds: 'FIRDS',
    lei: 'LEI',
    exchangeRates: 'ExchangeRates',
    annaDsbUpiEnrichment: 'annaDsbUpiEnrichment'
};

export default pseudoFunction;
